import {Injectable} from "@angular/core";
import {AccreditationBody, PriceFactor} from "../../store/state/order.state";
import {Observable} from "rxjs";
import {EndpointsProvider} from "../../umbrella-common/endpoints/endpoint-provider.service";
import {AppState} from "../../store/state/app.state";
import {Store} from "@ngrx/store";
import {orderSelector} from "../../store/state/state.selectors";
import {filter, first, map, mergeMap} from "rxjs/operators";

@Injectable()
export class PriceFactorsFetchService {

	constructor(private endpoints: EndpointsProvider, private store: Store<AppState>) {
	}

	fetchPriceFactors(): Observable<{ [accBody: string]: PriceFactor[]}> {
		return this.store.select(orderSelector).pipe(
			filter(order => order.clientCountry!= null),
			first(),
			map(order => order.products.map(p => p.accreditationBody)),
			mergeMap((accBodies: AccreditationBody[]) => this.endpoints.common.getPriceFactors(accBodies))
		);
	}
}
